import React, { useState, useCallback, useEffect, useRef } from "react";
import { CrudModal, MasterTable } from "../../components/_index";
import { deleteCategory, getCategory } from "../../services/category.service";
import {
  Box,
  Button,
  Dialog,
  Typography,
  TextField,
  Stack,
  Autocomplete,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate, useLocation } from "react-router-dom";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import NearMeIcon from "@mui/icons-material/NearMe";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { Formik, Form } from "formik";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import { AutoComplete } from "../../components/_index";
import { TICKET_PROGRESS_STATUS } from "../../constant/constant";
import { getSpecificUser } from "../../services/user.service";
import Styles from "../Transaction/Transaction.module.scss";
import {
  deleteTicket,
  getTicket,
  updateTicket,
  publicHolidays,
  callMailFunctApi,
} from "../../services/ticket.service";
import moment from "moment";
import AssignRequest from "./AssignRequest";
import CreateTicket from "./CreateTicket";
import { EMAIL_STATUS, ROLES } from "../../constant/constant";
import dayjs from "dayjs";
import { DatePicker } from "antd";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Timer from "../../utils/Timer";
import FilterList from "@mui/icons-material/FilterList";

const ServiceRequest = () => {
  const { RangePicker } = DatePicker;
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  // Get default tab from navigation state (from Dashboard cards)
  const defaultTabFromState = location.state?.defaultTab;

  const [tableTotalCount, setTableCount] = useState(0);
  const [openLoader, setOpenLoader] = useState(false);
  const [publicHoliday, setPublicHoliday] = useState([]);
  const [openTimerDrawer, setOpenTimerDrawer] = useState(false);
  const [statusValue, setStatusValue] = useState("Open");
  const [timerValue, setTimerValue] = useState(null);
  const [sendStatusValue, setSendStatusValue] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedTimerStatus, setSelectedTimerStatus] = useState(null);

  const [selectedSendStatus, setSelectedSendStatus] = useState(null);
  const dispatch = useDispatch();
  // const [columns, setColumns] = useState([]);
  const [selectedTab, setSelectedTab] = useState(
    defaultTabFromState || TICKET_PROGRESS_STATUS.PENDING
  );
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("MM-DD-YYYY")
  );
  const [selectedStartDate, setSelectedStartDate] = useState(
    dayjs().startOf("month")
  );
  const [selectedEndDate, setSelectedEndDate] = useState(
    dayjs().endOf("month")
  );
  const formattedStartDate = selectedStartDate.format("MM/DD/YYYY");
  const formattedEndDate = selectedEndDate.format("MM/DD/YYYY");

  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
    date: dayjs().format("MM-DD-YYYY"),
    progressStatus: selectedTab,
  });

  const [userData, setUserData] = useState([]);
  // const colorScheme = {
  //   0: ["#FFCDD2", "#000000"],
  //   2: ["#FFEB3B", "#000000"],
  //   1: ["#FFCDD2", "#000000"],
  //   3: ["#FFCDD2", "#000000"],
  //   4: ["#FFCDD2", "#000000"],
  //   5: ["#FFCDD2", "#000000"],
  // };
  const TimerComp = (e, type) => {
    let TIME = e?.createdAt;
    let END_TIME = null;
    let colorType = "4";
    let EXPIRY = Number(e?.expiry) || 2;
    let DURATION = 9;
    if (e?.tempEndTime) {
      const givenDay = moment.utc(e?.tempEndTime).startOf("day");
      const today = moment.utc().startOf("day");
      const hourTest = moment.utc(e?.tempEndTime).hour();
      if (givenDay.isSame(today) && hourTest < 18) {
        END_TIME = e?.tempEndTime;
      }
    }
    if (type === "INIT") {
      // colorType = "1";
      TIME = e?.createdAt;
      END_TIME = e?.initialEndTime || null;
      DURATION = 6;
      EXPIRY = 2;
    } else if (type === "FOLLOW_UP") {
      colorType = e?.followUpTime ? "3" : "1";
      TIME = e?.followUpTime;
      END_TIME = e?.followUpEndTime || null;
      EXPIRY = e?.expiry;
    } else if (type === "FINAL") {
      colorType = e?.finalTime ? "4" : "5";
      TIME = e?.finalTime;
      END_TIME = e?.finalEndTime || null;
      EXPIRY = e?.finalExpiry || 1;
    } else if (type === "ASSIGN") {
      colorType = "0";
      TIME = e?.createdAt;
      END_TIME = e?.assignedAt || null;
      DURATION = 1;
      EXPIRY = 1;
    }

    const dateStr = END_TIME ? moment(END_TIME) : null;
    let hours = null;
    let minutes = null;
    let seconds = null;
    if (dateStr) {
      hours = dateStr.hour();
      minutes = dateStr.minute();
      seconds = dateStr.second();
    }

    return (
      <Timer
        startDate={TIME}
        endHours={EXPIRY}
        holidays={publicHoliday}
        ticketStatus={e?.ticketStatus}
        endTime={e?.tempEndTime || null}
        id={e?._id}
        isExpired={e?.isExpired}
        WORK_END_HOUR={hours || 18}
        minutes={minutes || 0}
        seconds={seconds || 0}
        DURATION={DURATION}
      />
    );
  };
  const getPublicHolidays = async () => {
    try {
      const res = await publicHolidays();
      const modData = res?.data?.map((e) => e?.day ? dayjs(e?.day).format("YYYY-MM-DD") : false).filter(Boolean);
      setPublicHoliday(modData);
    } catch (error) {
      console.log(error);
    }
  };
  const getStatusInfo = (e) => {
    const filteredMsg = e?.replyMessages?.filter((e) => !e?.isAutoGenerated);
    let indx;
    const recentReplyData = filteredMsg?.[filteredMsg?.length - 1];

    for (indx = filteredMsg?.length - 2; indx >= 0;) {
      if (["2", "3", "4", "5"].includes(filteredMsg[indx]?.sendStatus)) {
        break;
      }
      indx--;
    }

    const recentReplyBeforeData = filteredMsg?.[indx];
    if (
      !recentReplyData?.sendStatus &&
      recentReplyBeforeData?.sendStatus == "5"
    ) {
      return "6";
    } else if (
      !recentReplyData?.sendStatus &&
      recentReplyBeforeData?.sendStatus == "4"
    ) {
      return "6";
    } else {
      return e?.sendStatus;
    }
  };

  function calculateWorkingSeconds(start, end) {
    const s = moment(start).clone();
    const e = moment(end).clone();

    if (!s.isValid() || !e.isValid() || !s.isBefore(e)) return 0;

    const holidaySet = new Set(publicHoliday);
    let totalSeconds = 0;

    let day = s.clone().startOf("day");
    const lastDay = e.clone().startOf("day");

    while (day.isSameOrBefore(lastDay)) {
      const dayKey = day.format("YYYY-MM-DD");
      const isSunday = day.day() === 0;

      if (!isSunday && !holidaySet.has(dayKey)) {
        const workStart = day.clone().hour(9).minute(0).second(0);
        const workEnd = day.clone().hour(18).minute(0).second(0);

        const segStart = moment.max(s, workStart);
        const segEnd = moment.min(e, workEnd);

        if (segStart.isBefore(segEnd)) {
          totalSeconds += segEnd.diff(segStart, "seconds");
        }
      }
      day.add(1, "day");
    }

    return Math.max(totalSeconds, 0);
  }

  // Switching tabs fires overlapping requests; only the latest one may fill
  // the table, otherwise a slower earlier tab's rows land under this tab.
  const fetchSeq = useRef(0);

  const fetchData = useCallback(async () => {
    const seq = ++fetchSeq.current;
    try {
      setOpenLoader(true);
      const res = await getTicket({
        ...queryParam,
        ...(selectedTab === "3" && {
          ticketStatus: "1",
          progressStatus: null,
        }),
        ...(selectedTab === TICKET_PROGRESS_STATUS.ASSIGNED && {
          ticketStatus: "0",
          assignedStartDate: formattedStartDate,
          isAssigned: true,
          assignedEndDate: formattedEndDate,
          timerType: selectedSendStatus,
          timerRangeType: selectedTimerStatus,
        }),
        ...(selectedTab === TICKET_PROGRESS_STATUS.CANCELLED && {
          updatedStartDate: formattedStartDate,
          updatedEndDate: formattedEndDate,
        }),
        ...(selectedTab === "3" && {
          closedStartDate: formattedStartDate,
          closedEndDate: formattedEndDate,
        }),
        ...(selectedTab === TICKET_PROGRESS_STATUS.REASSIGNED && {
          // ticketStatus: "0",
          assignedStartDate: formattedStartDate,
          assignedEndDate: formattedEndDate,
        }),
      });
      if (seq !== fetchSeq.current) return;

      const modifiedData =
        res?.data.map((e) => {
          // Use createdAt to match backend calculation for sorting consistency
          const created = moment(e?.createdAt || e?.ticketCreatedAt);
          const assigned = moment(e?.assignedAt);
          const diffInHours =
            assigned.isValid() && created.isValid()
              ? assigned.diff(created, "minutes") / 60
              : null;
          // const totalMinutes = assigned.diff(created, "minutes");
          // const hours = Math.floor(totalMinutes / 60);
          // const minutes = totalMinutes % 60;
          const totalMinutes = Math.ceil(
            assigned.diff(created, "seconds") / 60
          );
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;

          const readableDuration =
            hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;

          // Use backend's workingDuration (in HH:MM:SS format) if available, otherwise calculate
          const workingDuration = e?.workingDuration || readableDuration;

          function formatHms(seconds) {
            const hrs = Math.floor(seconds / 3600);
            const mins = Math.floor((seconds % 3600) / 60);
            const secs = Math.floor(seconds % 60);
            return `${hrs}h ${mins}m ${secs}s`;
          }

          /* === Usage === */
          let timeGap = "";
          if (e?.createdAt && e?.assignedAt) {
            const workingSeconds = calculateWorkingSeconds(
              e.createdAt,
              e.assignedAt
            );
            timeGap = formatHms(workingSeconds);
          }

          // Use backend's assignedToCompletedDuration (in HH:MM:SS format) if available, otherwise calculate
          let assignedToCompletedDuration = "";
          if (e?.assignedToCompletedDuration) {
            // Use backend's calculated value (already in HH:MM:SS format)
            assignedToCompletedDuration = e.assignedToCompletedDuration;
          } else if (e?.assignedAt && e?.closedAt) {
            // Fallback to frontend calculation if backend doesn't provide it
            const workingSeconds = calculateWorkingSeconds(
              moment(e.assignedAt),
              moment(e.closedAt)
            );
            const hours = Math.floor(workingSeconds / 3600);
            const minutes = Math.floor((workingSeconds % 3600) / 60);
            const seconds = workingSeconds % 60;
            // Format as HH:MM:SS to match backend format
            assignedToCompletedDuration = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
          }

          return {
            ...e,
            createdAt: e?.assignedAt
              ? moment(e?.assignedAt).format("DD MMM YYYY hh:mm a")
              : moment(e?.createdAt).format("DD MMM YYYY hh:mm a"),
            ticketCreatedAt: moment(e?.createdAt).format("DD MMM YYYY hh:mm a"),
            updatedAt: moment(e?.updatedAt).format("DD MMM YYYY hh:mm a"),
            assignedAt: e?.assignedAt ? moment(e?.assignedAt).format("DD MMM YYYY hh:mm a") : "-",
            closedAt: e?.closedAt ? moment(e?.closedAt).format("DD MMM YYYY hh:mm a") : "-",
            assignedTo: e?.assignedToInfo?.name || "-",
            assignedBy: e?.assignedByInfo?.name || "-",
            createdByName: e?.createdByName,
            createdByEmail: e?.createdByInfo?.email,
            modeType:
              e?.mode === "0" ? "Direct" : e?.mode === "1" ? "Mail" : "QR",
            conversation:
              e?.createdBy ===
                e?.replyMessages?.[e?.replyMessages.length - 1].userId
                ? "IN"
                : "OUT",
            StatusName:
              getStatusInfo(e) == "2"
                ? "Initial"
                : getStatusInfo(e) == "5"
                  ? "Need Info"
                  : getStatusInfo(e) == "4"
                    ? "Final"
                    : getStatusInfo(e) == "6"
                      ? "Response"
                      : "",
            hoursOfAssigned: readableDuration,
            // Use backend's workingDuration (HH:MM:SS format) for display, backend uses workingDurationMinutes for sorting
            workingDuration: workingDuration,
            no_of_msg_rec_send: `${e?.no_of_msg_rec} / ${e?.no_of_msg_send}`,
            initialTimer: TimerComp(e, "INIT"),
            followUpTimer: TimerComp(e, "FOLLOW_UP"),
            finalTimer: TimerComp(e, "FINAL"),
            assignTimer: TimerComp(e, "ASSIGN"),
            timer: TimerComp(e, null),
            timeGap,
            assignedToCompletedDuration,
          };
        }) || [];
      setTableCount(res?.totalCount || 0);
      setData(modifiedData);
      setOpenLoader(false);
    } catch (error) {
      if (seq !== fetchSeq.current) return;
      setData([]);
      setTableCount(0);
      setOpenLoader(false);
    } finally {
      if (seq === fetchSeq.current) setOpenLoader(false);
    }
  }, [queryParam, selectedDate, selectedTab]);

  useEffect(() => {
    fetchData();
  }, [selectedStartDate, selectedEndDate, queryParam]);

  useEffect(() => {
    setData([]);
    setOpenLoader(true);

    setQueryParam((prev) => ({
      ...prev,
      progressStatus: selectedTab,
      page: 1,
    }));
  }, [selectedTab]);

  useEffect(() => {
    setData([]);
    setOpenLoader(true);
  }, [queryParam.search, queryParam.date]);

  // useEffect(() => {
  //   if (openLoader) {
  //     const timer = setTimeout(() => {
  //       fetchData();
  //     }, 0);

  //     return () => clearTimeout(timer);
  //   }
  // }, [openLoader, fetchData]);

  const handleTabChange = async (tab) => {
    await callMailFunctApi();
    setSendStatusValue("");
    setTimerValue("");
    setReassign(false);
    setSelectedTab(tab);
  };

  const callFunct = async () => {
    await callMailFunctApi();
  };
  useEffect(() => {
    getSpecificUser().then((res) => {
      const modifiedData = res?.data?.data?.map((el) => ({
        ...el,
        label: el?.name,
      }));
      setUserData(modifiedData);
    });
    getPublicHolidays();
    callFunct();
  }, []);

  let columns = [
    { id: "createdAt", label: "Date & Time" },
    { id: "ticketId", label: "Ticket ID" },
    { id: "createdByName", label: "Name" },
    // { id: "categoryName", label: "Category" },
    { id: "subject", label: "Subject", Styles: "masterTableTextWrap" },
    { id: "modeType", label: "Mode" },
    { id: "assignTimer", label: "Timer" },
  ];

  let assignedColumns = [
    { id: "ticketCreatedAt", label: "Received Date" },
    { id: "assignedAt", label: "Assigned Date" },
    { id: "workingDuration", label: "Hours To Assigned" },
    { id: "ticketId", label: "Ticket ID" },
    { id: "createdByName", label: "Name" },
    { id: "subject", label: "Tittle", Styles: "masterTableTextWrap" },
    { id: "modeType", label: "Mode" },
    { id: "assignedTo", label: "Assigned To" },
    { id: "conversation", label: "Case Movement" },
    { id: "no_of_msg_rec_send", label: "No. of Rec / Send" },
    { id: "StatusName", label: "Status" },
    // { id: "initialTimer", label: "Initial Timer", width: 400 },
    // { id: "followUpTimer", label: "FollowUp Timer", width: 400 },
    // { id: "finalTimer", label: "Final Timer", width: 400 },
    { id: "timer", label: "Timer", width: 400 },
  ];

  let rejectedColumns = [
    { id: "updatedAt", label: "Date & Time" },
    { id: "ticketId", label: "Ticket ID" },
    { id: "createdByName", label: "Name" },
    // { id: "categoryName", label: "Category" },
    { id: "subject", label: "Subject", Styles: "masterTableTextWrap" },
    { id: "rejectedReason", label: "Rejected Reason" },
    { id: "modeType", label: "Mode" },
  ];
  let completedColumns = [
    { id: "ticketId", label: "Ticket ID" },
    { id: "createdByName", label: "Name" },
    { id: "assignedAt", label: "Assigned Time" },
    { id: "closedAt", label: "Completed Time" },
    { id: "assignedToCompletedDuration", label: "Total Duration" },
    { id: "assignedTo", label: "Assigned To" },
    { id: "assignedBy", label: "Assigned By" },
    // { id: "timeGap", label: "Hours taken to complete" },
    { id: "modeType", label: "Mode" },
  ];
  const [openDrawer, setOpenDrawer] = useState(false);
  const [rejectedOpenDrawer, setRejectedOpenDrawer] = useState(false);
  const [reassign, setReassign] = useState(false);
  const [reassignUser, setReassignUser] = useState(false);
  const [openAssignDrawer, setOpenAssignDrawer] = useState(false);
  const [openCreateDrawer, setOpenCreateDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  // A ticket created here is assigned in the same step, so land on the
  // Assigned tab where it now lives.
  const handleTicketCreated = () => {
    setOpenCreateDrawer(false);
    if (selectedTab === TICKET_PROGRESS_STATUS.ASSIGNED) {
      fetchData();
    } else {
      setSelectedTab(TICKET_PROGRESS_STATUS.ASSIGNED);
    }
  };
  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedDataId, setSelectedDataId] = useState(null);
  const handleDelete = (e) => {
    setSelectedDataId(e._id);
    setConfirmDeleteOpen(true);
  };

  const deleteFunction = async () => {
    try {
      const res = await deleteTicket(selectedDataId);
      setConfirmDeleteOpen(false);

      setData([]);
      setOpenLoader(true);
      // GetTicketData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };
  const handleAssingn = (e) => {
    // setOpenAssignDrawer(true);
    setOpenDrawer(true);
    setSelectedData(e);
  };
  const handleReAssingn = (e) => {
    // setOpenAssignDrawer(true);
    setOpenDrawer(true);
    setReassign(true);
    setReassignUser(false);
    setSelectedData(e);
  };

  const handleReAssingnUser = (e) => {
    // setOpenAssignDrawer(true);
    setOpenDrawer(true);
    setReassign(true);
    setReassignUser(true);
    setSelectedData(e);
  };

  const handleRejectView = (e) => {
    // setOpenAssignDrawer(true);
    setRejectedOpenDrawer(true);
    setSelectedData(e);
  };

  const handleRejectCase = (e) => {
    updateTicket(e._id, { isReAssigned: false }).then((res) => {
      dispatch(showToast({ message: res.message, type: "success" }));
      fetchData();
    });
  };

  const handleCancel = (e) => {
    setOpenAssignDrawer(true);
    // setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleNavigate = (e) => {
    const {
      assignTimer,
      finalTimer,
      followUpTimer,
      initialTimer,
      timer,
      ...ele
    } = e;

    // const query = new URLSearchParams(e).toString();
    navigate("/feedback", { state: ele });
  };

  const tableActionButton = [
    {
      title: "Assign",
      onClick: handleAssingn,
      btnIcon: <PersonAddIcon />,
    },
    {
      title: "Cancel",
      onClick: handleCancel,
      btnIcon: <CloseIcon sx={{ color: "red" }} />,
    },
  ];
  const tableActionButton2 = [
    {
      title: "Re Assign",
      onClick: handleReAssingn,
      btnIcon: <PersonAddIcon />,
    },
    {
      title: "Navigate",
      onClick: handleNavigate,
      btnIcon: <NearMeIcon sx={{ color: "#00675d" }} />,
    },
  ];
  const tableActionButton3 = [
    {
      title: "Reject",
      onClick: handleRejectCase,
      btnIcon: (
        <ClearIcon
          sx={{
            color: "red",
          }}
        />
      ),
    },
    {
      title: "Re Assign",
      onClick: handleReAssingnUser,
      btnIcon: <PersonAddIcon />,
    },
  ];

  const RejectedTabAction = [
    {
      title: "View",
      onClick: handleRejectView,
      btnIcon: <RemoveRedEyeIcon />,
    },
  ];

  const CompletedTabAction = [
    {
      title: "Navigate",
      onClick: handleNavigate,
      btnIcon: <NearMeIcon sx={{ color: "#00675d" }} />,
    },
  ];

  const [rejectedReason, setRejectedReason] = useState("");
  const cancelFunction = async () => {
    if (rejectedReason === "") {
      dispatch(
        showToast({ message: "Please enter rejected reason", type: "error" })
      );
    } else {
      const userId = localStorage.getItem("userId");

      const value = {
        assignedBy: userId,
        progressStatus: "2",
        rejectedReason: rejectedReason,
      };

      // Initialize the FormData
      // const formData = new FormData();
      // formData.append("values", JSON.stringify(value));

      try {
        await updateTicket(selectedData._id, value);
        setOpenAssignDrawer(false);
        setOpenLoader(true);
        await fetchData();
      } catch (error) {
        console.log(error);
      }
    }
  };

  const TimerStatusOption = [
    // { label: "All", value: 0 },
    { label: "In Progress", value: 1 },
    { label: "Completed", value: 2 },
  ];
  const TimerFilterOption = [
    { label: "All", value: null },
    { label: "With In Time", value: 1 },
    { label: "Out Of Time", value: 2 },
  ];
  const TimerSendStatusOption = [
    { label: "All", value: 1 },
    { label: "Initial", value: 2 },
    { label: "Need info", value: 5 },
    { label: "Response", value: 6 },
    { label: "Final", value: 4 },
  ];

  const filterFunction = async () => {
    setOpenTimerDrawer(false);
    const params = {
      // isAssigned: true,
      ticketStatus:
        selectedStatus === "Open"
          ? "0"
          : selectedStatus === "Closed"
            ? "1"
            : null,
      timerStatus: selectedStatus,
    };
    // await fetchData(params)
    setQueryParam((prev) => ({ ...prev, ...params }));
  };

  return (
    <div className="mainContent">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        mb={2}
      >
        <Tabs
          value={selectedTab}
        // onChange={(e, newValue) => handleTabChange(newValue)}
        // aria-label="basic tabs example"
        >
          <Tab
            label="Unassigned"
            // value={TICKET_PROGRESS_STATUS.PENDING}
            disabled={openLoader}
            className={
              selectedTab === TICKET_PROGRESS_STATUS.PENDING
                ? `${Styles.tabButton} ${Styles.selected}`
                : Styles.tabButton
            }
            onClick={() => handleTabChange(TICKET_PROGRESS_STATUS.PENDING)}
          />
          <Tab
            label="Assigned"
            // value={TICKET_PROGRESS_STATUS.ASSIGNED}
            disabled={openLoader}
            className={
              selectedTab === TICKET_PROGRESS_STATUS.ASSIGNED
                ? `${Styles.tabButton} ${Styles.selected}`
                : Styles.tabButton
            }
            onClick={() => handleTabChange(TICKET_PROGRESS_STATUS.ASSIGNED)}
          />
          <Tab
            label="Reassign"
            // value={TICKET_PROGRESS_STATUS.CANCELLED}
            disabled={openLoader}
            className={
              selectedTab === TICKET_PROGRESS_STATUS.REASSIGNED
                ? `${Styles.tabButton} ${Styles.selected}`
                : Styles.tabButton
            }
            onClick={() => handleTabChange(TICKET_PROGRESS_STATUS.REASSIGNED)}
          />
          <Tab
            label="Completed"
            // value={TICKET_PROGRESS_STATUS.CANCELLED}
            disabled={openLoader}
            className={
              selectedTab === "3"
                ? `${Styles.tabButton} ${Styles.selected}`
                : Styles.tabButton
            }
            onClick={() => handleTabChange("3")}
          />
          <Tab
            label="Reject"
            // value={TICKET_PROGRESS_STATUS.CANCELLED}
            disabled={openLoader}
            className={
              selectedTab === TICKET_PROGRESS_STATUS.CANCELLED
                ? `${Styles.tabButton} ${Styles.selected}`
                : Styles.tabButton
            }
            onClick={() => handleTabChange(TICKET_PROGRESS_STATUS.CANCELLED)}
          />
        </Tabs>
        <Box
          sx={{
            display: "flex",
            // justifyContent: "space-around",
            alignItems: "center",
            gap: 2,
          }}
        >
          {selectedTab === TICKET_PROGRESS_STATUS.ASSIGNED && (
            <Stack color="primary" className={Styles.inactiveButton}>
              <FilterList onClick={() => setOpenTimerDrawer(true)} />
            </Stack>
          )}
          {selectedTab !== TICKET_PROGRESS_STATUS.PENDING && (
            // <Box>
            //   <LocalizationProvider dateAdapter={AdapterDayjs}>
            //     <DemoContainer components={["DatePicker", "DatePicker"]}>
            //       <DatePicker
            //         // openTo="month"
            //         // views={["year", "month"]}
            //         value={dayjs(`${queryParam.date}`, "MM-DD-YYYY")}
            //         className="datePicker w-100"
            //         onChange={(e) => {
            //           const selectedDate = dayjs(e?.$d);
            //           setSelectedDate(selectedDate.format("MM-DD-YYYY"));
            //           setQueryParam({
            //             ...queryParam,
            //             date: selectedDate.format("MM-DD-YYYY"),
            //           });
            //         }}
            //       />
            //     </DemoContainer>
            //   </LocalizationProvider>
            // </Box>
            <Grid item xs={12} sm={1}>
              <Grid>
                <RangePicker
                  value={[selectedStartDate, selectedEndDate]}
                  onChange={(e) => {
                    setSelectedDate(e);
                    setSelectedStartDate(dayjs(e?.[0]));
                    setSelectedEndDate(dayjs(e?.[1]));
                  }}
                  style={{
                    height: "38px",
                    width: "220px",
                  }}
                />
              </Grid>
            </Grid>
          )}
          <Box className="SearchInputBoxContainer" sx={{ height: "100%" }}>
            <SearchOutlinedIcon className="Search_Icon" />
            <input
              className="SearchInputBox"
              placeholder="Search here"
              onChange={(e) => handleSearch(e.target.value)}
              style={{ height: "38px" }}
            />
          </Box>
          <Button
            onClick={() => setOpenCreateDrawer(true)}
            className="addButton"
            sx={{ whiteSpace: "nowrap" }}
          >
            <AddIcon />
            Create Ticket
          </Button>
        </Box>
      </Box>
      <MasterTable
        data={data}
        columns={
          selectedTab === "3"
            ? completedColumns
            : selectedTab === "2"
              ? rejectedColumns
              : selectedTab === "1"
                ? assignedColumns
                : selectedTab === "4"
                  ? assignedColumns
                  : columns
        }
        isServerSide={true}
        // handleView={handleView}
        // handleEdit={handleEdit}
        // handleDelete={handleDelete}
        tableActionButton={
          (selectedTab === TICKET_PROGRESS_STATUS.PENDING &&
            tableActionButton) ||
          (selectedTab === TICKET_PROGRESS_STATUS.ASSIGNED &&
            tableActionButton2) ||
          (selectedTab === TICKET_PROGRESS_STATUS.REASSIGNED &&
            tableActionButton3) ||
          (selectedTab === TICKET_PROGRESS_STATUS.CANCELLED &&
            RejectedTabAction) ||
          (selectedTab == "3" && CompletedTabAction)
        }
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
        openLoader={openLoader}
      />

      <Dialog
        open={openAssignDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="xs"
      >
        <CrudModal
          title={"Cancel"}
          open={true}
          handleClose={() => {
            setOpenAssignDrawer(false);
          }}
          maxWidth="xs"
        >
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12 }} mt={2}>
              <Typography className="inputLabel">
                {/* Are you sure you want to cancel? This action cannot be undone. */}
                Are you sure you want to cancel? This action cannot be undone
                without writing Rejected Reason
              </Typography>
            </Grid>
            <Grid size={{ xs: 12 }} mt={1}>
              <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                Rejected Reason
              </Typography>
              <TextField
                className="InputField"
                sx={{
                  height: "40px",
                  "& .MuiOutlinedInput-root": {
                    height: "100%",
                  },
                  "& .MuiInputBase-root": {
                    padding: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "gray",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "gray",
                  },
                  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "gray",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    fontSize: "12px",
                    color: "gray",
                  },
                }}
                onChange={(e) => setRejectedReason(e.target.value)}
                placeholder="Enter Rejected Reason"
              // fullWidth
              />
              <Box
                mt={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "20px",
                }}
              >
                {/* <Button
                          className="cancelButton"
                          onClick={() => setOpenAssignDrawer(false)}
                        >
                          Cancel
                        </Button> */}
                <Button
                  type="submit"
                  className="addButton"
                  onClick={() => cancelFunction()}
                >
                  Confirm
                </Button>
              </Box>
            </Grid>
          </Grid>
        </CrudModal>
      </Dialog>
      {openDrawer ? (
        <AssignRequest
          open={openDrawer}
          setOpenDrawer={setOpenDrawer}
          reassign={reassign}
          selectedData={selectedData}
          handleCloseDrawer={handleCloseDrawer}
          formType={
            selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
          }
          // formType={selectedData._id ? "edit" : "add"}
          GetTicketData={fetchData}
          reassignUser={reassignUser}
        />
      ) : null}
      {openCreateDrawer ? (
        <CreateTicket
          handleClose={() => setOpenCreateDrawer(false)}
          onCreated={handleTicketCreated}
        />
      ) : null}
      <Dialog
        open={openTimerDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="xs"
      >
        <CrudModal
          title={"Timer Filter"}
          open={true}
          handleClose={() => {
            setOpenTimerDrawer(false);
          }}
          maxWidth="xs"
        >
          <Box sx={{ gap: "10px" }}>
            <Typography mt={2} className="inputLabel">
              Type
            </Typography>

            <Autocomplete
              name="sendStatus"
              placeholder="Select Type"
              className="AutoComplete_InputBox"
              value={
                TimerSendStatusOption.find(
                  (option) => option.value === sendStatusValue
                ) || null
              }
              options={TimerSendStatusOption}
              onChange={(e, newValue) => {
                setSendStatusValue(newValue ? newValue.value : null);
                if (newValue && newValue.value === null) {
                  setSelectedSendStatus(null);
                } else {
                  setSelectedSendStatus(newValue ? newValue.value : null);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  focused={false}
                  placeholder="Select Status"
                />
              )}
            />
          </Box>
          {/* <Box sx={{ gap: "10px" }}>
            <Typography mt={2} className="inputLabel">
              Status
            </Typography>
            <Autocomplete
              name="status"
              disabled={!sendStatusValue}
              placeholder="Select Status"
              className="AutoComplete_InputBox"
              value={
                TimerStatusOption.find(
                  (option) => option.value === statusValue
                ) || null
              }
              options={TimerStatusOption}
              onChange={(e, newValue) => {
                setStatusValue(newValue ? newValue.value : null);
                if (newValue && newValue.value === null) {
                  setSelectedStatus(null);
                } else {
                  setSelectedStatus(newValue ? newValue.value : null);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  focused={false}
                  placeholder="Select Status"
                />
              )}
            />
          </Box> */}
          <Box sx={{ gap: "10px" }}>
            <Typography mt={2} className="inputLabel">
              Timer
            </Typography>

            <Autocomplete
              name="isExpired"
              disabled={!sendStatusValue}
              placeholder="Select Expired"
              className="AutoComplete_InputBox"
              value={
                TimerFilterOption.find(
                  (option) => option.value === timerValue
                ) || null
              }
              options={TimerFilterOption}
              onChange={(e, newValue) => {
                setTimerValue(newValue ? newValue.value : null);
                if (newValue && newValue.value === null) {
                  setSelectedTimerStatus(null);
                } else {
                  setSelectedTimerStatus(newValue ? newValue.value : null);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  focused={false}
                  placeholder="Select Status"
                />
              )}
            />
          </Box>
          <Grid size={{ xs: 12 }} mt={2}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px",
              }}
            >
              <Button
                className="cancelButton"
                onClick={() => setOpenTimerDrawer(false)}
              >
                Cancel
              </Button>
              <Button className="addButton" onClick={filterFunction}>
                Filter
              </Button>
            </Box>
          </Grid>
        </CrudModal>
      </Dialog>

      <Dialog
        open={rejectedOpenDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="xs"
      >
        <CrudModal
          title={"Rejected Reason"}
          open={true}
          handleClose={() => {
            setRejectedOpenDrawer(false);
          }}
          maxWidth="xs"
        >
          <Box sx={{ gap: "10px" }}>
            <Typography mt={2} fontWeight={"bold"} className="inputLabel">
              Reason :
            </Typography>
            <Typography mt={1}>{selectedData?.rejectedReason}</Typography>
          </Box>
        </CrudModal>
      </Dialog>

      <ConfirmBox
        open={confirmDeleteOpen}
        title="Are you sure you want to delete?"
        content={`You are about to delete this item`}
        confirmButton={"Delete"}
        setOpenConfirmBox={() => setConfirmDeleteOpen(false)}
        Function={deleteFunction}
      />
    </div>
  );
};

export default ServiceRequest;
